import {DriveItem} from "./drive-item";

export class DriveFile extends DriveItem {
    id: number;
    filePath: string;
    imageType: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.id = attributes['id'];
        this.name = attributes['filename_display'];
        this.createBy = attributes['user_contact'];
        this.filePath = attributes['file_path'];
        this.imageType = attributes['image_type'];
        this.type = attributes['file_extension'];
        this.creationTimestamp = attributes['creation_timestamp'];
        this.fileSize = attributes['file_size'];
    }
}
